import React, { useMemo, useState } from "react";

const CreatePageForm = ({ pageTitle, setPageTitle, pageDesc, setPageDesc, sections, selectedSectionIds, setSelectedSectionIds, onSubmit }) => {
  const [search, setSearch] = useState("");
  const visibleSections = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return sections;
    return sections.filter((section) => `${section.title || ""} ${section.description || ""} ${section.mode || ""}`.toLowerCase().includes(query));
  }, [search, sections]);

  const toggleSection = (id) => {
    setSelectedSectionIds((current) => current.includes(id) ? current.filter((sectionId) => sectionId !== id) : [...current, id]);
  };

  return (
    <div className="pb-card pb-create-card pb-create-card--page">
      <h2>Create Page</h2>
      <form onSubmit={onSubmit}>
        <label className="pb-label">Title</label>
        <input
          className="pb-input"
          value={pageTitle}
          onChange={(e) => setPageTitle(e.target.value)}
          placeholder="e.g. Factory Overview"
          required
        />

        <label className="pb-label">Description (optional)</label>
        <textarea
          className="pb-textarea"
          value={pageDesc}
          onChange={(e) => setPageDesc(e.target.value)}
          placeholder="Optional"
        />

        <div className="pb-inline-picker">
          <div className="pb-inline-picker-heading"><div><strong>Add sections to this page</strong><small>Optional · {selectedSectionIds.length} selected</small></div>{selectedSectionIds.length > 0 && <button type="button" className="pb-clear-btn" onClick={() => setSelectedSectionIds([])}>Clear</button>}</div>
          <input className="pb-input pb-picker-search" type="search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search sections…" />
          <div className="pb-picker-list">
            {visibleSections.map((section) => <label className={`pb-picker-option ${selectedSectionIds.includes(section.id) ? "is-selected" : ""}`} key={section.id}>
              <input type="checkbox" checked={selectedSectionIds.includes(section.id)} onChange={() => toggleSection(section.id)} />
              <span><strong>{section.title}</strong><small>{section.mode}</small></span>
            </label>)}
            {visibleSections.length === 0 && <div className="pb-picker-empty">No matching sections.</div>}
          </div>
        </div>

        <button className="pb-button" type="submit">
          Create Page
        </button>
      </form>
    </div>
  );
};

export default CreatePageForm;
